/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ months: NonNullable<unknown> }} Admin_Billing_Batch_Month_PluralInputs */

const es_admin_billing_batch_month_plural = /** @type {(inputs: Admin_Billing_Batch_Month_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.months} meses`)
};

const en_admin_billing_batch_month_plural = /** @type {(inputs: Admin_Billing_Batch_Month_PluralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.months} months`)
};

/**
* | output |
* | --- |
* | "{months} months" |
*
* @param {Admin_Billing_Batch_Month_PluralInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_batch_month_plural = /** @type {((inputs: Admin_Billing_Batch_Month_PluralInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Batch_Month_PluralInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_batch_month_plural(inputs)
	return en_admin_billing_batch_month_plural(inputs)
});
export { admin_billing_batch_month_plural as "admin.billing.batch.month_plural" }